<template>
  <div
    class="nav-category"
    @scroll="handleScroll()"
    :class="{ 'prevent-scroll': scrollLock }"
  >
    <SearchInput isResult />
    <SortBar
      @sort="selectedSort"
      @overlay="
        val => {
          scrollLock = val
        }
      "
    />
    <div v-if="products.length > 0" class="section-content">
      <div v-for="(product, key) in products" :key="key" class="item">
        <product-block v-bind="{ info: product, modifier: 's' }" />
      </div>
      <SpinnerBottom v-show="loading && products.length > 0" />
    </div>
    <div v-else-if="!loading" class="section-content no-product-section">
      <div class="flex-box">
        <div class="logo">
          <img src="@/assets/img/noproduct.svg" class="noproduct" />
        </div>
        <div class="title">沒找到合適的商品</div>
        <div class="subtitle">
          抱歉！目前沒有"{{ keyword }}"相關商品
          <br />
          要不要試試別的關鍵字查詢
        </div>
      </div>
    </div>
    <Spinner v-show="loading && products.length === 0"></Spinner>
  </div>
</template>
<script>
import Spinner from '@/components/shared/Spinner'
import SpinnerBottom from '@/components/shared/SpinnerBottom'
import ProductBlock from '@/components/ProductBlock'
import SearchInput from '@/components/search/SearchInput.vue'
import SortBar from '@/components/shared/SortBar.vue'

export default {
  name: 'SearchResult',
  components: {
    ProductBlock,
    SearchInput,
    Spinner,
    SpinnerBottom,
    SortBar,
  },
  data: function() {
    return {
      products: [],
      inTheEnd: false,
      loading: true,
      scrollLock: false,
      sort: 0,
      keyword: '',
      bidList: [],
      startIndex: 1,
      t1: 0,
      timer: null,
      isScrolling: false,
    }
  },
  methods: {
    selectedSort(value) {
      this.sort = value
      this.products = []
      this.startIndex = 1
      this.getProducts()
    },
    handleScroll() {
      if (this.loading) {
        return
      }
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      const windowHeight = window.screen.height
      const scrollBottom = scrollTop + windowHeight
      if (scrollBottom >= scrollHeight - 20 && !this.inTheEnd) {
        this.loading = true
        this.startIndex += 1
        this.getProducts()
      }
    },
    handleScrollForSort() {
      this.isScrolling = true
      clearTimeout(this.timer)
      this.timer = setTimeout(this.isScrollEnd, 500)
      this.t1 = document.documentElement.scrollTop || document.body.scrollTop
    },
    isScrollEnd() {
      this.isScrolling = false
    },
    searchResult() {
      api
        .searchProduct(this.keyword)
        .then(res => {
          this.bidList = res.data
          this.getProducts()
        })
        .catch(err => {
          console.log('searchProduct fail')
          console.log(err)
          this.loading = false
        })
    },
    getProducts(data) {
      this.loading = true
      if (data) this.bidList = data
      api
        .searchProductGetSort(this.bidList, this.sort, 24, this.startIndex)
        .then(res => {
          if (this.startIndex > 1) {
            this.products.push(...res.data.detail)
          } else {
            this.products = res.data.detail
          }
          this.loading = false
          this.inTheEnd = this.startIndex === res.data.page
        })
        .catch(err => {
          console.log('searchProductGetSort fail')
          console.log(err)
          this.loading = false
        })
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('scroll', this.handleScrollForSort)
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
      this.searchResult()
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scroll', this.handleScrollForSort)
  },
}
</script>

<style lang="scss" scoped>
.prevent-scroll {
  height: calc(100vh - 79px);
  overflow-y: hidden;
}
.filter-container {
  transition: all 0.2s ease;
  .row-sort {
    background-color: #fff;
    max-height: 363px;
    overflow-y: scroll;
    z-index: 999;
  }
}
.filter-container .col {
  box-shadow: inset 0 1px 0 0 #ededed;
  font-size: 15px;
  color: #4a4a4a;
  padding-left: 16px;
  padding-right: 24px;
  &.checked {
    font-weight: bold;
    color: #222;
  }
  &:last-child {
    box-shadow: none;
    padding-bottom: 89px;
  }
}
.filter-container .col img {
  float: right;
}
.nav-category {
  min-height: 100%;
  overflow: hidden;
  background-color: #f3f3f3;
}
.section-content {
  margin-top: 114px;
  display: flex;
  padding: 16px 11.5px;
  padding-bottom: 180px;
  flex-flow: row wrap;
  background-color: #fff;
  > .item {
    width: 50%;
    flex: 0 1 calc(50% - 9px);
    margin: 0 4.5px 10px 4.5px;
  }
}

.no-product-section {
  min-height: calc(100vh - 114px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0%;
  padding-bottom: 0%;
  .logo {
    text-align: center;
    display: block;
  }
  .title {
    font-family: PingFangTC;
    font-weight: bold;
    font-size: 18px;
    color: #4a4a4a;
    display: block;
    text-align: center;
    line-height: 2em;
  }
  .subtitle {
    font-family: PingFangTC;
    font-weight: normal;
    font-size: 14px;
    columns: #4a4a4a;
    display: block;
    text-align: center;
    font-size: 14px;
    line-height: 1.7em;
  }
  .noproduct {
    width: 72px;
    height: 72px;
    object-fit: contain;
  }
}
</style>
